import { useEffect, useState } from "react";
import { Switch, Route } from "react-router-dom";
import { ApplicationUIProvider } from "../../ApplicationUiContext";
import { defaultApplcationContext } from "../../interfaces/ApplicationContext";
import { FLayout, FContainer, FMain } from "ferrum-design-system";
import { IS_MULTISWAP } from "../../../../utils/const.utils";
import { getWindowDimensions } from "../../../../utils/helperFunctions";
import { Redirect } from "react-router";
import { Toaster } from "react-hot-toast";
import MyTradesPage from "../../pages/my-trades/MyTrades";
import SwapPage from "../../pages/swap/SwapPage";
import AbandonedTransactionPage from "../abandoned-transaction/AbandonedTransactionPage";
import CrucibleDashboardPage from "../../../crucible/dashboard/CrucibleDashboardPage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/rootReducer";
import * as SwapActions from "../../../../redux/slices/swap";

const Lander = () => {
  const dispatch = useDispatch();
  const [applicationContext, setApplicationContext] = useState(
    defaultApplcationContext
  );
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const { tokenV2: token } = useSelector(
    (state: RootState) => state.walletAuthenticator
  );

  useEffect(() => {
    if (windowDimensions) {
      setApplicationContext({
        ...applicationContext,
        isMobile: windowDimensions.width <= 991,
      });
    }
    // eslint-disable-next-line
  }, [windowDimensions]);

  useEffect(() => {
    if (token) {
      dispatch(SwapActions.getAllTokens(token as string));
    }
  }, [token]);

  return (
    <>
      <ApplicationUIProvider ApplicationUIContents={applicationContext}>
        <FLayout
          themeBuilder={false}
          fontFamily="futuristic"
          className={"f-font-futuristic"}
        >
          <Toaster
            // toastOptions={{
            //   style: {
            //     background: "#D23232",
            //     color: "#FFFFFF",
            //     height: "40px",
            //   },
            // }}
            position="top-center"
            reverseOrder={false}
          />
          <FMain>
            <FContainer type="fluid">
              <Switch>
                <Route
                  exact={true}
                  path={`/swap`}
                  component={() => <SwapPage />}
                />
                <Route
                  exact={true}
                  path={`/my-trades`}
                  component={MyTradesPage}
                />
                <Route
                  exact={true}
                  path={`/abandoned-tx`}
                  component={AbandonedTransactionPage}
                />
                <Route
                  exact={true}
                  path={`/dashboard/crucible`}
                  component={() => <CrucibleDashboardPage />}
                />
                {IS_MULTISWAP ? <Redirect from="/" to={`/swap`} /> : null}
              </Switch>
            </FContainer>
          </FMain>
        </FLayout>
      </ApplicationUIProvider>
    </>
  );
};

export default Lander;
